'use es6';

import { Map as ImmutableMap } from 'immutable';
import CrmObjectTypeRecord from 'customer-data-filters/models/CrmObjectTypeRecord';
import PortalIdParser from 'PortalIdParser';
import cache from '../requestCaches/objectDefinitionCache';
import createDSAdapter from './createDSAdapter';
import http from 'hub-http/clients/apiClient';
const makeObjectDefinitionsAdapter = ({
  isAssetFamilySupported,
  includeObject
}) => {
  const endpointAll = 'inbounddb-meta/v1/object-types/for-portal';
  const endpointBatched = 'inbounddb-meta/v1/object-types/batch-get';
  function parseObjectDefinitions(objectDefinitions) {
    return objectDefinitions.reduce((acc, objectDefinition) => {
      const {
        name,
        objectTypeId,
        pluralForm,
        singularForm,
        primaryDisplayLabelPropertyName
      } = objectDefinition;
      if (!includeObject(objectDefinition)) {
        return acc;
      }
      const customObjectInfo = CrmObjectTypeRecord({
        name,
        objectTypeId,
        pluralForm,
        singularForm,
        primaryDisplayLabelPropertyName
      });
      acc = acc.set(objectTypeId, customObjectInfo);
      return acc;
    }, ImmutableMap());
  }
  function getFetcherFromProps() {
    return http.get;
  }
  function fetch(httpClient, {
    ids
  } = {}) {
    const hasObjectIds = Array.isArray(ids) && ids.length;
    const endpoint = hasObjectIds ? endpointBatched : endpointAll;
    if (cache[endpoint]) {
      return Promise.resolve(cache[endpoint]);
    }
    const options = {
      query: {
        portalId: PortalIdParser.get()
      }
    };
    if (hasObjectIds) {
      options.query.objectType = ids;
    }
    return httpClient(endpoint, options).then(response => {
      cache[endpoint] = response;
      return response;
    });
  }
  function updater(result) {
    return parseObjectDefinitions(result);
  }
  return createDSAdapter({
    fetch,
    getFetcherFromProps,
    isAssetFamilySupported,
    updater
  });
};
export default makeObjectDefinitionsAdapter;